import { Skeleton } from "../ui/skeleton";

import RequestVolumeTail from "@/components/RequestVolumeTail";

enum ItemType {
  Folder = "folder",
  Item = "item",
}

const LoadingCards = ({ count = 6, type = ItemType.Item }: { count?: number; type?: ItemType }) => (
  <div className="grid h-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
    {Array.from({ length: count }, (_, i) => (
      <div
        key={`registry-shimmer-${type}-${i + 1}`}
        aria-hidden="true"
        className={`flex h-full w-full flex-col overflow-hidden rounded-lg border border-gray-200 bg-white transition-all duration-200 ease-in-out ${
          type === ItemType.Item ? "min-h-[150px]" : "h-auto"
        }`}
      >
        <div className="mt-0.5 flex h-full w-full flex-col px-3 pb-2 pt-1.5">
          {/* Card Header */}
          <div className="flex items-center justify-between">
            <div className="flex min-w-0 flex-1 items-center gap-x-2">
              <Skeleton className="!h-7 !w-7 flex-shrink-0 rounded-lg" />
              <Skeleton className="h-4 w-32 flex-1" />
            </div>
          </div>

          {/* Card Body and Tags */}
          {type === ItemType.Item && (
            <Skeleton className="mt-2 flex min-h-0 flex-1 flex-col items-start justify-between" />
          )}
        </div>
      </div>
    ))}
  </div>
);

const RegistryLoadingState = ({ showBanner = false }: { showBanner?: boolean }) => (
  <>
    {showBanner && <RequestVolumeTail skeleton />}
    <div className="px-8 py-6">
      <div className="mb-12">
        <h2 className="mb-4 text-sm font-normal text-gray-600">Folders</h2>
        <LoadingCards count={8} type={ItemType.Folder} />
      </div>
      <div className="mb-12">
        <h2 className="mb-4 text-sm font-normal text-gray-600">Items</h2>
        <LoadingCards count={24} />
      </div>
    </div>
  </>
);

export default RegistryLoadingState;
